module.exports = __webpack_public_path__ + "img/logo_xianyu.bb8bda27.png";